var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 16.333L4.33301 9.66634L6.19967 7.73301L9.66634 11.1997V0.333008H12.333V11.1997L15.7997 7.73301L17.6663 9.66634L10.9997 16.333ZM2.99967 21.6663C2.26634 21.6663 1.63856 21.4052 1.11634 20.883C0.594119 20.3608 0.333008 19.733 0.333008 18.9997V14.9997H2.99967V18.9997H18.9997V14.9997H21.6663V18.9997C21.6663 19.733 21.4052 20.3608 20.883 20.883C20.3608 21.4052 19.733 21.6663 18.9997 21.6663H2.99967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.010c067d111be9c9424085f3ba917f8b.svg";
export { ForwardRef as ReactComponent };